import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HomeworkActivityQuery } from '@examdojo/homework';
import { QuestionAttemptEntityQuery, QuestionAttemptEntityService } from '@examdojo/question';
import { SolutionCaptureService } from '@examdojo/solution';
import { distinctUntilChanged, filter, finalize, merge, Observable, tap } from 'rxjs';

@Injectable()
export class CloseSolutionCaptureDialogHomeworkEffectService {
  constructor(
    private readonly solutionCaptureService: SolutionCaptureService,
    private readonly questionAttemptQuery: QuestionAttemptEntityQuery,
    private readonly questionAttemptService: QuestionAttemptEntityService,
    private readonly homeworkActivityQuery: HomeworkActivityQuery,
  ) {
    merge(
      this.shouldCloseSolutionCaptureDialogOnAttemptStatusChange(),
      this.shouldCloseSolutionCaptureDialogOnActivityChange(),
    )
      .pipe(
        finalize(() => {
          if (this.solutionCaptureService.isDialogOpen()) {
            this.solutionCaptureService.dismiss();
          }
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  readonly activeHomeworkActivityId$: Observable<string | undefined> = this.homeworkActivityQuery.ongoingActivityId$;

  private shouldCloseSolutionCaptureDialogOnAttemptStatusChange() {
    return this.questionAttemptQuery.attemptStatus$.pipe(
      distinctUntilChanged(),
      filter((status) => !!status && status !== 'PENDING'),
      tap((status) => {
        if (status === 'GRADED' || status === 'FAILED') {
          this.questionAttemptService.setOpenCaptureDialogFlag(false);
          this.solutionCaptureService.dismiss();
        }
      }),
    );
  }

  private shouldCloseSolutionCaptureDialogOnActivityChange() {
    return this.activeHomeworkActivityId$.pipe(
      distinctUntilChanged(),
      tap((activeHomeworkActivityId) => {
        if (!activeHomeworkActivityId) {
          this.questionAttemptService.setOpenCaptureDialogFlag(false);
          this.solutionCaptureService.dismiss();
        }
      }),
    );
  }
}
